import React from 'react';
import { Clock, CreditCard, ChevronRight, Loader2, Crown } from 'lucide-react';

const Step1_ServiceSelect = ({ services, onSelect, isLoading, checkIsMember }) => {
  const visibleServices = services.filter((s) => {
    if (!Array.isArray(s?.fixed_slots) || s.fixed_slots.length === 0) {
      return true;
    }

    const now = new Date();

    const hasUpcomingSlot = s.fixed_slots.some((slot) => {
      if (!slot?.date || !slot?.start) return false;

      const [year, month, day] = String(slot.date).split("-").map(Number);
      const [hour, minute] = String(slot.start).split(":").map(Number);

      const startAt = new Date(year, month - 1, day, hour, minute, 0, 0);
      if (Number.isNaN(startAt.getTime())) return false;

      const durationMin = Number(
        slot?.duration_minutes ??
        slot?.durationMinutes ??
        s?.duration ??
        60
      );

      const endAt = new Date(startAt.getTime() + durationMin * 60000);

      return endAt > now;
    });

    return hasUpcomingSlot;
  });

  return (
    <div className="p-6 space-y-4 animate-in slide-in-from-right duration-300">
      {isLoading && <Loader2 className="animate-spin mx-auto text-gray-900"/>}
      {!isLoading && visibleServices.length === 0 && (
        <div className="text-center py-10 text-gray-500 text-xs font-bold">
          メニューがありません
        </div>
      )}
      
      {visibleServices.map(s => {
        const isUserMember = checkIsMember(s);
        const tiers = s.price_tiers || [];
        const minPrice = tiers.length > 0
          ? Math.min(...tiers.map(t =>
              isUserMember && t.member_price !== undefined ? t.member_price : t.price
            ))
          : s.price;
          
        return (
          <div
            key={s.id}
            onClick={() => onSelect(s)}
            className="bg-white p-5 rounded-3xl shadow-sm border border-gray-200 active:scale-95 transition-all cursor-pointer group hover:shadow-md relative overflow-hidden"
          >
            <div className="flex justify-between items-start mb-2">
              <div className="min-w-0">
                <h3 className="font-black text-gray-800 text-lg leading-tight">{s.name}</h3>
                {(s.gender_mode === 'male' || s.gender_mode === 'female') && (
                  <span className={`inline-block mt-1.5 text-[9px] font-black px-2 py-0.5 rounded-xl border ${
                    s.gender_mode === 'male'
                      ? 'bg-gray-50 text-gray-900 border-gray-200'
                      : 'bg-red-50 text-red-500 border-red-100'
                  }`}>
                    {s.gender_mode === 'male' ? '男性限定' : '女性限定'}
                  </span>
                )}
              </div>
              <div className="bg-gray-50 p-2 rounded-full text-gray-300 group-hover:bg-gray-900 group-hover:text-white transition-colors">
                <ChevronRight size={16}/>
              </div>
            </div>
              
            <div className="flex gap-3 mt-4">
              <span className="flex items-center gap-1.5 bg-gray-50 px-3 py-1.5 rounded-xl text-xs font-bold text-gray-500">
                <Clock size={12}/> {s.duration}分
              </span>

              <span className={`flex items-center gap-1.5 px-3 py-1.5 rounded-xl text-xs font-black transition-colors ${
                isUserMember 
                  ? 'bg-amber-50 text-amber-700 border border-amber-200/50'
                  : 'bg-gray-50 text-gray-500'
              }`}>
                {isUserMember ? (
                  <>
                    <Crown size={12} className="fill-amber-500 text-amber-600"/>
                    <span className="text-[10px] opacity-80 mr-0.5">会員</span>
                  </>
                ) : (
                  <CreditCard size={12}/>
                )}
                ¥{Number(minPrice).toLocaleString()}~
              </span>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default Step1_ServiceSelect;